import { FilterOperatorType } from "../../../../../../../services/cloudchipr.api";

const singleSelectOperators = ["is"];

export const filterValueIsSingleSelectByOperator = (
  operator: FilterOperatorType,
) => {
  return singleSelectOperators.includes(operator);
};
